import request from '@/utils/request'
import API from '@/api/dw-admin/index.js'

// 登录方法
export function dwAdminSurveyList (pageSize, current, surveyName, surveyState,language, groupId2) {
  const params = {
    pageSize,
    current,
    surveyName,
    surveyState,
    language,
    groupId2
  }
  return request({
    url: API.adminSurveyList,
    method: 'get',
    params
  })
}

export function dwAdminSurveyDelete (data) {
  return request({
    url: API.adminSurveyDelete,
    method: 'delete',
    data
  })
}

export function dwSurveyAnswerLogStatsUpdateAll (params) {
  return request({
    url: '/api/dwsurvey/admin/update-log-data-sync.do',
    method: 'get',
    params
  })
}

export function dwAdminSurveyAnaswerLogList (params) {
  return request({
    url: '/api/dwsurvey/admin/survey-answer-log/list.do',
    method: 'get',
    params
  })
}




// WEBPACK FOOTER //
// ./src/api/dw-admin/dw-admin-survey/dw-admin-survey.js